/* eslint-disable no-fallthrough */
import React from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules } from '@utils';

import { useStore } from '@modules';

import style from './ZHDisclaimerInfo.scss';

const cn = bemCssModules(style, 'ZHDisclaimerInfo');

const ZHDisclaimerInfo: CustomFC = ({ className }) => {
  const { t } = useTranslation();
  const [{ operationBlock }] = useStore();

  return operationBlock.consentRequired === 'zh' ? (
    <div className={cn(null, [className])}>
      <div className={cn('disclaimer')}>
        {t('zh.agreements.payments')} {t('zh.agreements.network')}
      </div>
      <div className={cn('disclaimer-email')}>{t('zh.agreements.email')}</div>
    </div>
  ) : null;
};

export default ZHDisclaimerInfo;
